// Generated by purs version 0.13.8
"use strict";
var $foreign = require("./foreign.js");
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Category = require("../Control.Category/index.js");
var Control_Monad_State_Class = require("../Control.Monad.State.Class/index.js");
var Control_MonadZero = require("../Control.MonadZero/index.js");
var Control_Promise = require("../Control.Promise/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Lens_Record = require("../Data.Lens.Record/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Effect_Aff_Class = require("../Effect.Aff.Class/index.js");
var Effect_Class = require("../Effect.Class/index.js");
var Halogen_Component = require("../Halogen.Component/index.js");
var Halogen_HTML_Core = require("../Halogen.HTML.Core/index.js");
var Halogen_HTML_Elements = require("../Halogen.HTML.Elements/index.js");
var Halogen_HTML_Events = require("../Halogen.HTML.Events/index.js");
var Halogen_HTML_Properties = require("../Halogen.HTML.Properties/index.js");
var Halogen_HTML_Properties_ARIA = require("../Halogen.HTML.Properties.ARIA/index.js");
var Halogen_Query_HalogenM = require("../Halogen.Query.HalogenM/index.js");
var Lunarbox_Component_Utils = require("../Lunarbox.Component.Utils/index.js");
var ClosedWith = (function () {
    function ClosedWith(value0) {
        this.value0 = value0;
    };
    ClosedWith.create = function (value0) {
        return new ClosedWith(value0);
    };
    return ClosedWith;
})();
var BubbledAction = (function () {
    function BubbledAction(value0) {
        this.value0 = value0;
    };
    BubbledAction.create = function (value0) {
        return new BubbledAction(value0);
    };
    return BubbledAction;
})();
var CloseModal = (function () {
    function CloseModal(value0) {
        this.value0 = value0;
    };
    CloseModal.create = function (value0) {
        return new CloseModal(value0);
    };
    return CloseModal;
})();
var Bubble = (function () {
    function Bubble(value0) {
        this.value0 = value0;
    };
    Bubble.create = function (value0) {
        return new Bubble(value0);
    };
    return Bubble;
})();
var Close = (function () {
    function Close(value0) {
        this.value0 = value0;
    };
    Close.create = function (value0) {
        return new Close(value0);
    };
    return Close;
})();
var Open = (function () {
    function Open(value0) {
        this.value0 = value0;
    };
    Open.create = function (value0) {
        return new Open(value0);
    };
    return Open;
})();
var UpdateInput = (function () {
    function UpdateInput(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    UpdateInput.create = function (value0) {
        return function (value1) {
            return new UpdateInput(value0, value1);
        };
    };
    return UpdateInput;
})();
var component = function (dictMonadEffect) {
    return function (dictMonadAff) {
        var render = function (v) {
            var titleId = v.id + "-title";
            var contentId = v.id + "-content";
            return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.id_(v.id), Halogen_HTML_Properties_ARIA.hidden("true"), Lunarbox_Component_Utils.className("modal micromodal-slide") ])([ Halogen_HTML_Elements.div([ Halogen_HTML_Properties.tabIndex(-1 | 0), Halogen_HTML_Properties.attr("data-micromodal-close")("true"), Lunarbox_Component_Utils.className("modal__overlay") ])([ Halogen_HTML_Elements.div([ Halogen_HTML_Properties_ARIA.role("dialog"), Halogen_HTML_Properties.attr("aria-modal")("true"), Halogen_HTML_Properties_ARIA.labelledBy(titleId), Lunarbox_Component_Utils.className("modal__container") ])([ Halogen_HTML_Elements.header([ Lunarbox_Component_Utils.className("modal__header") ])([ Halogen_HTML_Elements.h2([ Halogen_HTML_Properties.id_(titleId), Lunarbox_Component_Utils.className("modal__title") ])([ Halogen_HTML_Core.text(v.title) ]) ]), Halogen_HTML_Elements.main([ Halogen_HTML_Properties.id_(contentId), Lunarbox_Component_Utils.className("modal__content") ])([ v.content(Bubble.create) ]), Halogen_HTML_Elements.footer([ Lunarbox_Component_Utils.className("modal__footer") ])(Data_Functor.map(Data_Functor.functorArray)(function (v1) {
                return Halogen_HTML_Elements.button([ Halogen_HTML_Properties.classes(Data_Functor.map(Data_Functor.functorArray)(Halogen_HTML_Core.ClassName)(Data_Semigroup.append(Data_Semigroup.semigroupArray)(Data_Functor.voidRight(Data_Functor.functorArray)("modal__btn-primary")(Control_MonadZero.guard(Control_MonadZero.monadZeroArray)(v1.primary)))([ "modal__btn" ]))), Halogen_HTML_Events.onClick(Data_Function["const"](Data_Maybe.Just.create(new CloseModal(v1.value)))) ])([ Halogen_HTML_Core.text(v1.text) ]);
            })(v.buttons)) ]) ]) ]);
        };
        var handleQuery = function (v) {
            if (v instanceof Open) {
                return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (v1) {
                    return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Data_Functor["void"](Halogen_Query_HalogenM.functorHalogenM)(Halogen_Query_HalogenM.fork(Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))($foreign.showModal(v1.id)))(function (promise) {
                        return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Data_Functor["void"](Halogen_Query_HalogenM.functorHalogenM)(Effect_Aff_Class.liftAff(Halogen_Query_HalogenM.monadAffHalogenM(dictMonadAff))(Control_Promise.toAff(promise))))(function () {
                            return Halogen_Query_HalogenM.raise(new ClosedWith(v1.onClose));
                        });
                    }))))(function () {
                        return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value0));
                    });
                });
            };
            if (v instanceof Close) {
                return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                    return v1.id;
                }))(function (id) {
                    return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))($foreign.closeModal(id)))(function () {
                        return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value0));
                    });
                });
            };
            if (v instanceof UpdateInput) {
                return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.put(Halogen_Query_HalogenM.monadStateHalogenM)(v.value0))(function () {
                    return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value1));
                });
            };
            throw new Error("Failed pattern match at Lunarbox.Component.Modal (line 124, column 17 - line 139, column 25): " + [ v.constructor.name ]);
        };
        var handleAction = function (v) {
            if (v instanceof CloseModal) {
                return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                    return v1.id;
                }))(function (id) {
                    return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))($foreign.closeModal(id)))(function () {
                        return Halogen_Query_HalogenM.raise(new ClosedWith(v.value0));
                    });
                });
            };
            if (v instanceof Bubble) {
                return Halogen_Query_HalogenM.raise(new BubbledAction(v.value0));
            };
            throw new Error("Failed pattern match at Lunarbox.Component.Modal (line 108, column 18 - line 113, column 40): " + [ v.constructor.name ]);
        };
        return Halogen_Component.mkComponent({
            initialState: Control_Category.identity(Control_Category.categoryFn),
            render: render,
            "eval": Halogen_Component.mkEval({
                handleAction: handleAction,
                handleQuery: handleQuery,
                receive: Halogen_Component.defaultEval.receive,
                initialize: Halogen_Component.defaultEval.initialize,
                finalize: Halogen_Component.defaultEval.finalize
            })
        });
    };
};
var _open = function (dictStrong) {
    return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "open";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
};
module.exports = {
    Close: Close,
    Open: Open,
    UpdateInput: UpdateInput,
    CloseModal: CloseModal,
    Bubble: Bubble,
    ClosedWith: ClosedWith,
    BubbledAction: BubbledAction,
    component: component
};
